export interface ApiErrorResponse {
  message?: string;
  errors?: Record<string, any> | string[];
}

export function formatErrorMessage(error: any): string {
  if (!error) return 'Si è verificato un errore sconosciuto';

  let baseMessage = '';
  let firstError = '';

  // Extract base message
  if (error.response?.data?.message) {
    baseMessage = error.response.data.message;
  } else if (error.message) {
    baseMessage = error.message;
  } else {
    baseMessage = 'Si è verificato un errore';
  }

  // Extract first error if errors array/object is populated
  const errors = error.response?.data?.errors;
  if (errors) {
    if (Array.isArray(errors) && errors.length > 0) {
      firstError = errors[0];
    } else if (typeof errors === 'object' && Object.keys(errors).length > 0) {
      const firstKey = Object.keys(errors)[0];
      const firstErrorValue = errors[firstKey];
      if (Array.isArray(firstErrorValue) && firstErrorValue.length > 0) {
        firstError = firstErrorValue[0];
      } else if (typeof firstErrorValue === 'string') {
        firstError = firstErrorValue;
      }
    }
  }

  // Combine messages if we have both
  if (firstError && firstError !== baseMessage) {
    return `${baseMessage}: ${firstError}`;
  }

  return baseMessage;
}